import React from 'react';
import { useIntl } from "react-intl";

//Helpers
import { endpoints } from 'Core/defaultValues';

//Components
import { IconButton, Button } from '@gpstrackit/gtc-react-controls';

const Welcome = ({ startProcess, openChat }) => {
    
    const { messages } = useIntl();

    return (
        <div className="troubleshoot-device-welcome">
            <p>{messages['troubleshootDevice_isThisDeviceNotReportingCorrectly']}</p>
            <p>
                {messages['troubleshootDevice_clickStartToBeginTroubleshooting']}
                {' '}
                <IconButton
                    className="troubleshoot-device-welcome-icon-agent"
                    size="small"
                    icon="support_agent_icon"
                    onClick={(e) => {
                        e.preventDefault();
                        openChat && openChat();
                    }}
                />{' '}
                {messages['troubleshootDevice_supportForAdditionalAssistance']}
            </p>
            <p>
                {messages['troubleshootDevice_alternatively']} {' '}
                <IconButton
                    onClick={(e) => {
                        e.preventDefault();
                        window.open(endpoints.TROUBLESHOOTING_URL, "_blank", "noopener,noreferrer")
                    }}
                    className="troubleshoot-device-welcome-icon-new"
                    size="small"
                    icon="open_in_new"
                />
            </p>
            <div className="troubleshoot-device-welcome-container-button">
                <Button
                    variant="green"
                    onClick={startProcess}
                >
                    {messages['start']}
                </Button>
            </div>
        </div>
    )
}

export default Welcome